export const BOOLEAN_REQUIRED = 'booleanRequired';
export const EMAIL_VALIDATOR = 'emailValidator';
export const EMAIL_ALREADY_EXISTS_VALIDATOR = 'emailAlreadyExistsValidator';
export const USER_ALREADY_EXISTS_VALIDATOR = 'userAlreadyExistsValidator';
export const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
export async function booleanRequired(value) {
    const valid = Boolean(value);
    return [{
            message: valid ? '' : 'tws.validator.required',
            name: 'booleanRequired',
            valid,
        }];
}
export async function emailValidator(value) {
    let valid = true;
    let message = '';
    if (value) {
        valid = !!value && Boolean(value.match(EMAIL));
        message = !valid ? 'account.result.email.validator' : '';
    }
    return [{
            name: EMAIL_VALIDATOR,
            message,
            valid,
        }];
}
export async function emailAlreadyExistsValidator() {
    const valid = false;
    return [{
            name: EMAIL_ALREADY_EXISTS_VALIDATOR,
            message: 'create-user.email-already-activated',
            valid,
        }];
}
export async function userAlreadyExistsValidator() {
    const valid = false;
    return [{
            name: USER_ALREADY_EXISTS_VALIDATOR,
            message: 'newaccount.backend.error.user.used',
            valid,
        }];
}
//# sourceMappingURL=validators.js.map